import report from "../assets/icons/sidebar/reports.svg";
import reportb from "../assets/icons/sidebar/reportsb.svg";
import trans from "../assets/icons/sidebar/trans.svg";
import transb from "../assets/icons/sidebar/transb.svg";
import { linkModel } from "./models";
import { UI_AUTHENTICATED_ROUTES } from "../constants/routes";

export const sideBar: linkModel[] = [
  {
    icon: report,
    iconw: reportb,
    name: "API Calls",
    link: UI_AUTHENTICATED_ROUTES.REPORTS,
  },
  {
    icon: trans,
    iconw: transb,
    name: "Transactions",
    link: UI_AUTHENTICATED_ROUTES.TRANSACTIONS,
  },
];

export const reportStatusOptions = [
  { value: "SUCCESS", label: "success" },
  { value: "FAILURE", label: "failure" },
  { value: "INITIATED", label: "initiated" },
];

export const txnStatusOptions = [
  { value: "", label: "all" },
  { value: "CREDIT", label: "credit" },
  { value: "DEBIT", label: "debit" },
];
